import cableService from '@/widget/services/cableService';
import { useChatWidgetContext } from '@/widget/services/useChatWidgetContext';
import { useStore } from 'zustand';
import generateKey from '@/lib/generate_key';

export default function useInitConversation() {
  const { store } = useChatWidgetContext();
  const conversationKey = generateKey(23);
  const { setActiveConversationKey, setMode } = useStore(store, (state) => state);

  function initConversation() {
    setActiveConversationKey(conversationKey);
    setMode('conversation');
    window.ChatWidget.cable.subscriptions.create(
      { channel: 'ChatWidgetChannel', key: conversationKey },
      {
        received: (data) => cableService(data, store),
      },
    );
  }

  return {
    initConversation,
  };
}
